import { checkEqualOrIncludes } from "./checkEqualOrIncludes";
import { ConfigFilter, SelectedFilters } from "../types";

export const getFilterValue = <T extends string | number>({
  selectedFilters,
  configFilters,
  filterName,
  newValue,
}: {
  selectedFilters: SelectedFilters;
  configFilters: ConfigFilter[];
  filterName: string;
  newValue?: T;
}): T[] => {
  const value = selectedFilters?.[filterName]?.value as T[];
  const configFilter = configFilters?.find(({ name }) => name === filterName);
  const { valueType, defaultValue } = configFilter || {};

  if (value?.length && Array.isArray(value)) {
    if (["range", "single"].includes(valueType)) {
      return value[0] === newValue && value[1] === newValue ? [] : [newValue, newValue];
    }

    const result = [...value];
    const filterIndex = result.indexOf(newValue as T);

    if (filterIndex >= 0) {
      result.splice(filterIndex, 1);
    } else {
      result.push(newValue as T);
    }

    return result;
  }

  if (!value) {
    if (checkEqualOrIncludes(defaultValue, newValue)) {
      return [];
    }

    if (defaultValue) {
      return [newValue, ...(Array.isArray(defaultValue) ? (defaultValue as T[]) : [defaultValue as T])];
    }
  }

  return [newValue, newValue];
};
